import {Pipe, PipeTransform} from '@angular/core';
import { Moment, MomentInput } from 'moment';

declare let moment: (inp?: MomentInput) => Moment;
@Pipe({name: 'moment'})
export class MomentPipe implements PipeTransform {
   transform(s: MomentInput, pattern?: string): string {
      const m = moment(s);
      return pattern ? m.format(pattern) : m.fromNow();
   }
}
